module.exports = __webpack_public_path__ + "media/images/pulse-comment-icon-6c6c23348563deace48fdda0339765c3.svg";